import { render } from "./TheTinhTrangDen.vue?vue&type=template&id=5f5da3c0"
import script from "./TheTinhTrangDen.vue?vue&type=script&lang=js"
export * from "./TheTinhTrangDen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__